import { DatabaseModel, DatabaseModelElement, GetResponse } from "./DatabaseModel";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import { formatDate } from "../utils/formatDate";
import { isAfter, isBefore } from "date-fns";
import Subscription from "./Subscription";
import axios from "axios";

export enum Status {
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
  UNBLOCKED = "UNBLOCKED",
}

export enum StatusInvoicing {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
}

export enum Period {
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum Type {
  QR = "QR",
  KIOSK = "KIOSK",
  PICKUP_DELIVERY = "PICKUP_DELIVERY",
  TABLET = "TABLET",
  CATALOG = "CATALOG",
  SERVER = "SERVER",
  CUSTOM = "CUSTOM",
  DATADRIVEN_AI = "DATADRIVEN_AI",
}

export default class SubscriptionLine extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsSubscriptionLine";

  constructor(
    public id: number = 0,
    public subs_subscription_id: number = 0,
    public description: string | null = null,
    public notes: string | null = null,
    public type: Type | null = null,
    public count: number | null = null,
    public unit_price: number | null = null,
    public start_date: Date | null = null,
    public end_date: Date | null = null,
    public next_date: Date | null = null,
    public status: Status = Status.ACTIVE,
    public status_invoicing: StatusInvoicing = StatusInvoicing.ACTIVE,
    public period: Period = Period.MONTH,
    public invoice_period: object = { every: { months: 1 } },
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null,
    public subscription: Subscription | null = null
  ) {
    super();
  }

  static CreateModel(model: any): SubscriptionLine {
    return new SubscriptionLine(
      model.id,
      model.subs_subscription_id,
      model.description,
      model.notes,
      model.type,
      model.count,
      model.unit_price,
      model.start_date ? new Date(model.start_date) : null,
      model.end_date ? new Date(model.end_date) : null,
      model.next_date ? new Date(model.next_date) : null,
      model.status,
      model.status_invoicing,
      model.period,
      model.invoice_period,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null,
      model.subscription ? Subscription.CreateModel(model.subscription) : null
    );
  }

  isActive(): boolean {
    const statusOk = this.status === Status.ACTIVE || this.status === Status.UNBLOCKED;
    const timePeriodOk =
      this.start_date != null &&
      (this.end_date == null || isBefore(new Date(), this.end_date)) &&
      isAfter(new Date(), this.start_date);

    return statusOk && timePeriodOk;
  }

  public apiEndSubscriptionLine(endDate: any, sendFinalInvoice: boolean, finalInvoiceDate: any): Promise<any> {
    // only send newValues or all values if there are no newValues set
    const data: any = {};
    data.end_date = endDate;
    data.send_final_invoice = sendFinalInvoice;
    data.final_invoice_date = finalInvoiceDate;
    data.id = this.id;
    return new Promise((resolve: (value: GetResponse<any>) => void, reject) => {
      axios
        .post("core/" + (this.constructor as typeof DatabaseModel).modelName + "/endSubscriptionLine", data)
        .then((response) => {
          resolve({
            model: (this.constructor as typeof DatabaseModel).CreateModel(response.data.data),
            response,
          });
        });
    });
  }

  static tableRowHeader() {
    return (
      <TableRow>
        <TableCell>Start Date</TableCell>
      </TableRow>
    );
  }

  tableRow() {
    return (
      <TableRow>
        <TableCell>{this.start_date != null ? formatDate(this.start_date) : "Not started"}</TableCell>
      </TableRow>
    );
  }
}
